import React, { useState } from 'react';
import { TextField, Box, CircularProgress } from '@mui/material';
import { formatRut, validateRut } from '../../utils/rutUtils';

const BuscadorPacientes = ({ onSearch, isLoading }) => {
  const [rut, setRut] = useState('');
  const [error, setError] = useState('');

  const handleRutChange = (event) => {
    const newRut = formatRut(event.target.value);
    setRut(newRut);
    setError('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // Validar formato del RUT
    if (!validateRut(rut)) {
      setError('RUT inválido');
      return;
    }

    // Asegurarse de que el RUT tenga el formato correcto (XX.XXX.XXX-X)
    const rutFormateado = formatRut(rut);
    onSearch(rutFormateado);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 600, margin: '0 auto' }}>
      <Box sx={{ position: 'relative' }}>
        <TextField
          fullWidth
          label="Ingrese el RUT para ver su historial médico"
          variant="outlined"
          value={rut}
          onChange={handleRutChange}
          error={!!error}
          helperText={error || 'Formato: 12.345.678-9'}
          placeholder="12.345.678-9"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
        />
        {isLoading && (
          <CircularProgress
            size={24}
            sx={{
              position: 'absolute',
              right: 12,
              top: '50%',
              marginTop: '-12px',
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default BuscadorPacientes; 